<lab-loading *ngIf="isLoading"></lab-loading>
<app-toast></app-toast>
<router-outlet></router-outlet>
